(function () {
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initVariantPicker(root) {
    var variantsJson = root.querySelector('[data-bb-variants-json]');
    if (!variantsJson) return;
    var variants;
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      return;
    }
    var selects = root.querySelectorAll('[data-bb-option-select]');
    var productInfo = root.closest('product-info');
    var hiddenInput = productInfo ? productInfo.querySelector('[data-bb-variant-input]') : null;

    function currentVariant() {
      var values = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.filter(function (v) {
        return values.every(function (val, i) { return v.options[i] === val; });
      })[0];
    }

    function update() {
      var variant = currentVariant();
      if (!variant) return;
      if (hiddenInput) hiddenInput.value = variant.id;
      if (productInfo) productInfo.dataset.productId = variant.id;
      var priceEl = productInfo ? productInfo.querySelector('.bb-precio__actual') : null;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      var compareEl = productInfo ? productInfo.querySelector('.bb-precio__tachado') : null;
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      var submitBtn = productInfo ? productInfo.querySelector('.bb-buyform__submit') : null;
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'Añadir al carrito' : 'Agotado';
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
  }

  document.querySelectorAll('[data-bb-variants]').forEach(initVariantPicker);

  function clickMainCta() {
    var packsBtn = document.querySelector('[data-bb-packs-submit]');
    if (packsBtn) {
      packsBtn.click();
      return;
    }
    var buyForm = document.querySelector('.bb-buyform__submit');
    if (buyForm) {
      buyForm.click();
      return;
    }
    var mainProduct = document.querySelector('[id^="MainProduct-"]');
    if (mainProduct) mainProduct.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.querySelectorAll('[data-bb-cta-final]').forEach(function (btn) {
    btn.addEventListener('click', clickMainCta);
  });

  document.querySelectorAll('[data-bb-sticky-cta]').forEach(function (btn) {
    btn.addEventListener('click', clickMainCta);
  });

  var stickyBar = document.querySelector('[data-bb-sticky-bar]');
  var mainCtaEl = document.querySelector('[data-bb-packs-submit]') || document.querySelector('.bb-buyform__submit');
  if (stickyBar && mainCtaEl) {
    var ticking = false;
    function checkVisibility() {
      var rect = mainCtaEl.getBoundingClientRect();
      var pastCta = rect.bottom < 0;
      stickyBar.dataset.visible = pastCta ? 'true' : 'false';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(checkVisibility);
        ticking = true;
      }
    }, { passive: true });
    checkVisibility();
  }

  function initGallery(root) {
    var mainItems = root.querySelectorAll('[data-bb-media-id]');
    var thumbs = root.querySelectorAll('[data-bb-thumb]');
    if (!thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var target = thumb.getAttribute('data-target');
        mainItems.forEach(function (item) {
          item.classList.toggle('is-active', item.getAttribute('data-bb-media-id') === target);
        });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  }
  document.querySelectorAll('[data-bb-gallery]').forEach(initGallery);

  function initScrollReveal() {
    var items = document.querySelectorAll('.bb-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('bb-is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bb-is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { observer.observe(el); });
  }
  initScrollReveal();

  document.querySelectorAll('[data-bb-header]').forEach(function (header) {
    var openBtn = header.querySelector('[data-bb-menu-open]');
    var closeBtn = header.querySelector('[data-bb-menu-close]');
    var drawer = header.querySelector('[data-bb-menu-drawer]');
    var overlay = header.querySelector('[data-bb-menu-overlay]');

    function openMenu() {
      if (drawer) drawer.dataset.open = 'true';
      if (overlay) overlay.dataset.open = 'true';
    }
    function closeMenu() {
      if (drawer) drawer.dataset.open = 'false';
      if (overlay) overlay.dataset.open = 'false';
    }
    if (openBtn) openBtn.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);

    var cartBtn = header.querySelector('[data-bb-cart-open]');
    if (cartBtn) {
      cartBtn.addEventListener('click', function () {
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else if (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) {
          window.location.href = window.Shopify.routes.cart_url;
        }
      });
    }
  });

  document.querySelectorAll('[data-bb-packs]').forEach(function (packsEl) {
    var section = packsEl.closest('product-info');
    var sectionId = section ? section.dataset.section : null;
    var variantId = section ? section.dataset.productId : null;
    var packs = packsEl.querySelectorAll('.bb-pack');
    var submitBtn = packsEl.querySelector('[data-bb-packs-submit]');
    var totalEl = packsEl.querySelector('[data-bb-packs-total]');

    function selectPack(pack) {
      packs.forEach(function (p) { p.setAttribute('data-selected', 'false'); });
      pack.setAttribute('data-selected', 'true');
      var price = pack.querySelector('.bb-pack__price');
      if (totalEl && price) totalEl.textContent = '— ' + price.textContent;
    }

    packs.forEach(function (pack) {
      pack.addEventListener('click', function () { selectPack(pack); });
      pack.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectPack(pack);
        }
      });
      if (pack.getAttribute('data-selected') === 'true') selectPack(pack);
    });

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        var selected = packsEl.querySelector('.bb-pack[data-selected="true"]');
        if (!selected) return;
        var qty = parseInt(selected.getAttribute('data-qty'), 10) || 1;
        var realVariantId = getRealVariantId(section);
        if (!realVariantId) return;

        submitBtn.disabled = true;
        var originalText = submitBtn.innerHTML;
        submitBtn.textContent = '[[Añadiendo…]]';

        var body = JSON.stringify({
          items: [{ id: realVariantId, quantity: qty }],
          sections: getCartSections(),
          sections_url: window.location.pathname
        });

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.cart_add_url : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: body
        })
          .then(function (res) { return res.json(); })
          .then(function (state) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalText;
            if (state.status) {
              console.error('[Beyond Basics] cart add error', state);
              return;
            }
            handleCartSuccess(state);
          })
          .catch(function (err) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalText;
            console.error('[Beyond Basics] cart add failed', err);
          });
      });
    }
  });

  function getRealVariantId(section) {
    if (!section) return null;
    var input = section.querySelector('input[name="id"], select[name="id"]');
    if (input && input.value) return input.value;
    return section.dataset.productId || null;
  }

  function getCartSections() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    return [];
  }

  function handleCartSuccess(state) {
    document.querySelectorAll('[data-bb-cart-count]').forEach(function (el) {
      if (state.item_count !== undefined) {
        el.textContent = state.item_count;
      } else if (state.items) {
        var total = state.items.reduce(function (sum, i) { return sum + i.quantity; }, 0);
        el.textContent = total;
      }
    });

    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) {
        window.location.href = window.Shopify.routes.cart_url;
      }
      return;
    }

    fetch(window.location.pathname + '?sections=' + getCartSections().join(','))
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'bb-packs',
            cartData: state,
            variantId: state.items && state.items[0] ? state.items[0].variant_id : null
          });
        }
        if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(sections);
        }
        cartDrawer.classList.remove('is-empty');
        var inner = cartDrawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        if (typeof cartDrawer.open === 'function') cartDrawer.open();
      })
      .catch(function (err) {
        console.error('[Beyond Basics] cart sections refresh failed', err);
      });
  }
})();
